<template>
  <v-dialog width="300px" v-model="showModal" persistent>
    <v-card>
      <v-card-title class="headline text-center">
        <strong>Você tem certeza que deseja {{ msgConfirmation }} </strong>
      </v-card-title>

      <v-card-text>
        <div class="text-center">
          <v-icon class="car-door">car-door</v-icon>
        </div>

        <div v-if="command == 'changeStep'">
          <h6>Adicionar imagens:</h6>

          <div
            v-for="(formField, index) in formFields"
            :key="index"
            :value="formField.id"
          >
            <v-file-input
              v-model="image"
              show-size
              :label="formField.description"
              @change="$emit('inputChanged', formField.id)"
            >
            </v-file-input>
          </div>
        </div>
      </v-card-text>
      <v-card-actions class="text-center align-center">
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" @click="$emit('btnNao')">
          Não
        </v-btn>
        <v-btn color="green darken-1" @click="$emit('btnSim', command)">
          Sim
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    showModal: Boolean,
    formFields: Array,
    msgConfirmation: String,
    command: String,
  },
  data: () => ({}),
};
</script>
